var map = {
	"./b2b-img1.jpg": 3792,
	"./b2b-img2.jpg": 3793,
	"./b2b-img3.jpg": 3794,
	"./b2b-img4.jpg": 3795,
	"./b2b-img5.jpg": 3796,
	"./b2b-img6.jpg": 3797
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5071;